import roundToTwoDecimals from "@Number/roundToTwoDecimals";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import {
    CountAmenitySelectedType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenitySelected.type";
import entries from "@Object/entries";
import {AmenityGroupType} from "@CheckOrder/features/amenities/types/AmenityGroup.type";
import {CountAmenityType} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenity.type";

/**
 * Out of currently selected amenities inside amenity modal create a total price.
 */
export default function useCreateTotalPriceOfCurrentlySelectedAmenities(
    pairedAmenityGroups: PairedSingleAndReturnAmenitiesType,
    singleSelectedAmenities: Record<string, CountAmenitySelectedType>,
    returnSelectedAmenities: Record<string, CountAmenitySelectedType>
) {
    const getAmenity = (amenities: CountAmenityType[], key: string) => (
        amenities.find((amenity) => (amenity.key === key))
    )

    const sumPerDirection = (selectedAmenities: Record<string, CountAmenitySelectedType>, amenityGroup: AmenityGroupType) => {
        if (!entries(selectedAmenities ?? {}).length) {
            return 0
        }
        return (
            roundToTwoDecimals(
                entries(selectedAmenities).reduce((sum, [key, selectedAmenity]) => {
                    if (getAmenity(amenityGroup.amenities, key)) {
                        return (
                            sum + getAmenity(amenityGroup.amenities, key).priceInUserCurrency * selectedAmenity.value
                        )
                    }

                    return sum
                }, 0)
            )
        )
    }

    const amenityPriceSingle = sumPerDirection(singleSelectedAmenities, pairedAmenityGroups.singleGroup)
    const amenityPriceReturn = sumPerDirection(returnSelectedAmenities, pairedAmenityGroups.returnGroup)

    return {
        totalPrice: roundToTwoDecimals(amenityPriceSingle + amenityPriceReturn),
    }
}